import * as React from "react"

// NOTE: the default context value is only used during tests
export const OldUIContext = React.createContext({} as OldUIContext.OldUIContext)

export default OldUIContext
